"use strict";

export class AgentService {
	constructor(config) {
		this.queue = "";
		this.sms = "";
		this.fax = "";
		this.breaks = "";
		this.phones = "";
		this.user = "";
		this.serverUrl = config.serverUrl;
		if (this.serverUrl[this.serverUrl.length - 1] != "/") {
			this.serverUrl += "/";
		}
	}

	makeApiRequest(method, url, data) {
		let headers = {
			Authorization: "Bearer " + localStorage.token
		};
		let requestConfig = {
			headers, method
		};
		if (!["HEAD", "GET"].includes(method) && data) {
			requestConfig.body = JSON.stringify(data);
			headers["Content-Type"] = "application/json";
		}
		return fetch(this.serverUrl + url, requestConfig).then(r => r.text()).then(r => {
			console.info("makeApiRequest", r);
			return r[0] == "{" ? JSON.parse(r) : r;
		});
	}

	makeApiGetRequest(url) {
		return this.makeApiRequest("GET", url);
	}

	makeApiPostRequest(url, data) {
		return this.makeApiRequest("POST", url, data);
	}

	async getBreaks(forceReload = true) {
		if (forceReload || !this.breaks) {
			this.breaks = await this.makeApiGetRequest("getAgentToolBarBreaks");
		}
		return this.breaks;
	}

	makeCall(data) {
		return this.makeApiPostRequest("MakeCall", data);
	}

	transferCall(data) {
		return this.makeApiPostRequest("transferCall", data);
	}

	changeAgentStatus(data) {
		return this.makeApiPostRequest("agentChangeStatus", data);
	}

	virtualLogin(data) {
		return this.makeApiPostRequest("virutalLogin", data);
	}

	virtualLogout(data) {
		return this.makeApiPostRequest("virutalLogout", data);
	}

	getAgentStatus() {
		return this.makeApiGetRequest("getAgentStatus");
	}

	// getCampaignTemplate(surveyId) {
	// 	return $http.get('https://www.015dialer.net/functions/surveyAPI.php?action=getSurvey&id=' + surveyId);
	// }

	// saveLead(data) {
	// 	return $http.post('https://www.015dialer.net/functions/surveyAPI.php?action=save', data);
	// }

	// getUrl(id) {
	// 	return $http.get('https://www.015dialer.net/functions/surveyAPI.php?action=getUrl&id=' + id);
	// }

	sendSMS(data) {
		return this.makeApiPostRequest("sendSMS", data);
	}

	sendFax(data) {
		return this.makeApiPostRequest("toolbar/sendFax", data);
	}

	getReport() {
		return this.makeApiGetRequest("toolbarReport");
	}

	getRegisteredPhones(force = true) {
		if (force || !this.phones) {
			this.phones = this.makeApiGetRequest("getRegisterPhones").then(response => {
				if (response[0] !== "{" && response[0] != "[") {
					throw new Error("invalid response from getRegisteredPhones: " + response);
				}
				return JSON.parse(response);
			});
		}
		return this.phones;
	};

	async getSMS(data, force = true) {
		if (force || !this.sms) {
			this.sms = await this.makeApiGetRequest("getSMS", data);
			console.log(this.sms);
		}
		return this.sms;
	};

	getQueues() {
		if (!this.queue) {
			this.queue = this.makeApiGetRequest("getAllQues");
		}
		return this.queue;
	};

	switchQueues(data) {
		return this.makeApiPostRequest("switchQueuesToolBar", data);
	};

	getUserData(extension, force = true) {
		if (!this.user || force) {
			this.user = this.makeApiGetRequest("getUserData/" + extension).then(response => response.data);
		}
		return this.user;
	};

	getNumberInfoFromCRM(number) {
		return this.makeApiGetRequest("proxy/crm/getByNumber?number=" + number).then(response => response.item);
	};

	getWebrtcPopupLink() {
		return this.makeApiGetRequest("toolbar/get-webrtc-link").then(response => response.popupLink);
	}
}
